import React from 'react'

function MessageManagementAddEdit() {
  return (
    <div>MessageManagementAddEdit</div>
  )
}

export default MessageManagementAddEdit